import restApi from "@plannel/services/utils/rest-api";
import { format } from "date-fns";

const getAll = (params) => {
  return restApi.get("/api/plan-version", { params });
};

const getVersionForMaster = (params) => {
  return restApi.get("/api/plan-version/master", { params });
};

const getAllVersion = () => {
  return restApi.get("/api/plan-version/all");
};

const getVersionByName = (params) => {
  return restApi.get("/api/plan-version/all", { params });
};

const get = id => {
  return restApi.get(`/api/plan-version/${id}`);
};

const getStatusPlanVersion = (params) => {
  return restApi.get("/api/plan-version/status", { params });
}

/** moduleCd + statusCds 배열로 plan version 조회 (IpScenarioAiRecommend 등에서 사용) */
const getPlanVersionByStatus = (moduleCd, statusCds) => {
  return restApi.get("/api/plan-version/status", {
    params: { moduleCd, statusCds: statusCds.join(",") },
  });
}

const getDpScenarioMain = () => {
  return restApi.get("/api/plan-version/dp/scenario/main");
}

const create = data => {
  return restApi.post("/api/plan-version/create", data);
}

const upsert = data => {
  return restApi.post("/api/plan-version", data);
};

const createScenario = data => {
  return restApi.post("/api/plan-version/scenario", data);
};

const createVersionName = (params) => {
  params.nowDateString = format(new ZDate(), "yyyyMMdd");
  return restApi.get("/api/plan-version/create-name", { params });
};

const release = data => {
  return restApi.post("/api/plan-version/dp/release", data);
};

const resetStatus = () => {
  return restApi.get("/api/plan-version/reset/status");
};

const remove = ids => {
  return restApi.delete(`/api/plan-version/${ids}`);
};

const updateSummary = versionId => {
  return restApi.post("/api/plan-version/update-summary", versionId);
};

const makeDemand = data => {
  return restApi.post("/api/plan-version/create/demand", data);
};

const delFlg = (params) => {
  return restApi.post("/api/plan-version/delflg", params);
};

const restoreVersion = version => {
  return restApi.post("/api/plan-version/restore", version);
}

const deleteVersionWithData = ids => {
  return restApi.delete(`/api/plan-version/data/${ids}`);
}

const planVersionService = {
  getAll,
  getVersionForMaster,
  getAllVersion,
  getVersionByName,
  release,
  resetStatus,
  getDpScenarioMain,
  get,
  getStatusPlanVersion,
  getPlanVersionByStatus,
  create,
  upsert,
  createScenario,
  createVersionName,
  remove,
  updateSummary,
  makeDemand,
  delFlg,
  restoreVersion,
  deleteVersionWithData
};

export default planVersionService;